import { apiSlice } from "../../app/api/apiSlice";

export const contractorsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContractors: builder.query({
      query: (params) => ({
        url: "/api/v1/accounts/contractors/",
        params,
      }),
      providesTags: ["Contractor"],
    }),
    getContractor: builder.query({
      query: (id) => `/api/v1/accounts/contractors/${id}/`,
      providesTags: (result, error, id) => [{ type: "Contractor", id }],
    }),
    createContractor: builder.mutation({
      query: (data) => ({
        url: "/api/v1/accounts/contractors/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Contractor"],
    }),
    updateContractor: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/v1/accounts/contractors/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Contractor"],
    }),
    deleteContractor: builder.mutation({
      query: (id) => ({
        url: `/api/v1/accounts/contractors/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Contractor"],
    }),

    // The 고객 페르소나 a 파트너's trainees are offered, as one set (PUT replaces it).
    getContractorPersonas: builder.query({
      query: (id) => `/api/v1/accounts/contractors/${id}/personas/`,
      providesTags: (result, error, id) => [{ type: "ContractorPersonas", id }],
    }),
    setContractorPersonas: builder.mutation({
      query: ({ id, persona_ids }) => ({
        url: `/api/v1/accounts/contractors/${id}/personas/`,
        method: "PUT",
        body: { persona_ids },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "ContractorPersonas", id }, "Contractor", "CustomerPersona"],
    }),

    // Contractor Admins
    getContractorAdmins: builder.query({
      query: (params) => ({
        url: "/api/v1/accounts/contractor-admins/",
        params,
      }),
      providesTags: ["ContractorAdmin"],
    }),
    createContractorAdmin: builder.mutation({
      query: (data) => ({
        url: "/api/v1/accounts/contractor-admins/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ContractorAdmin"],
    }),
    deleteContractorAdmin: builder.mutation({
      query: (id) => ({
        url: `/api/v1/accounts/contractor-admins/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ContractorAdmin"],
    }),

    // Invite Links
    getInviteLinks: builder.query({
      query: (params) => ({
        url: "/api/v1/accounts/contractor-invite-links/",
        params,
      }),
      providesTags: ["InviteLink"],
    }),
    createInviteLink: builder.mutation({
      query: (data) => ({
        url: "/api/v1/accounts/contractor-invite-links/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["InviteLink"],
    }),
    updateInviteLink: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/v1/accounts/contractor-invite-links/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["InviteLink"],
    }),
    deleteInviteLink: builder.mutation({
      query: (id) => ({
        url: `/api/v1/accounts/contractor-invite-links/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["InviteLink"],
    }),
    validateInviteToken: builder.query({
      query: (token) => `/api/v1/accounts/contractor-invite-links/validate/?token=${encodeURIComponent(token)}`,
      keepUnusedDataFor: 0,
    }),

    // User approval (also used in UsersList)
    approveUser: builder.mutation({
      query: (id) => ({
        url: `/api/v1/accounts/users/${id}/approve/`,
        method: "POST",
      }),
      invalidatesTags: ["User"],
    }),
    rejectUser: builder.mutation({
      query: (id) => ({
        url: `/api/v1/accounts/users/${id}/reject/`,
        method: "POST",
      }),
      invalidatesTags: ["User"],
    }),

    // Onboarding
    submitOnboarding: builder.mutation({
      query: (data) => ({
        url: "/api/v1/accounts/onboarding/",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetContractorsQuery,
  useGetContractorQuery,
  useCreateContractorMutation,
  useUpdateContractorMutation,
  useDeleteContractorMutation,
  useGetContractorPersonasQuery,
  useLazyGetContractorPersonasQuery,
  useSetContractorPersonasMutation,
  useGetContractorAdminsQuery,
  useCreateContractorAdminMutation,
  useDeleteContractorAdminMutation,
  useGetInviteLinksQuery,
  useCreateInviteLinkMutation,
  useUpdateInviteLinkMutation,
  useDeleteInviteLinkMutation,
  useLazyValidateInviteTokenQuery,
  useApproveUserMutation,
  useRejectUserMutation,
  useSubmitOnboardingMutation,
} = contractorsApiSlice;
